export default __webpack_public_path__ + "static/media/header-logo.2d9cfaa0.png";